export default __webpack_public_path__ + "static/media/template_pro__0017_10---StephenChid.ab61a2f8.png";